/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import type { FC } from 'react';

import type { ICommonTranslation } from '@modules/internationalization/types';
import { TableCellNoValue } from '@modules/table';

import type { IReportsSubscriberTable } from '../types';

interface ITableReportsSubscriberCellPersData {
    commonTranslation: ICommonTranslation,
    row: IReportsSubscriberTable;
}

export const TableReportsSubscriberCellPersData: FC<ITableReportsSubscriberCellPersData> = (
    { commonTranslation, row }) => {

    const description = typeof row.persDataStatusDescription === 'string' ? row.persDataStatusDescription : '';
    const hintCode = typeof row.persDataHintCode === 'string' ? row.persDataHintCode : '';

    const hint = description
        || (hintCode && (commonTranslation.status.codes[hintCode] || commonTranslation.status.defaultMessage));

    if (typeof row.persDataStatusName !== 'string') return <TableCellNoValue />

    return (
        <>
            {hint && (
                <div className='personal-data-hint' style={{ display: 'none' }}>{hint}</div>
            )}
            <div className='table__tooltip-text'>
                {row.persDataStatusName}
            </div>
        </>
    );
};
